import { IconButton, Tooltip, Button, Box } from "@mui/material";
import Iconify from "./iconify";

export default function Previous({
  onClick,
  hasResults,
}: {
  onClick: any;
  hasResults?: boolean;
}) {
  return (
    <Tooltip title="Go to Previous Page">
      {!hasResults ? (
        <IconButton onClick={onClick}>
          <Iconify icon={"akar-icons:chevron-left"} />
        </IconButton>
      ) : (
        <Box sx={{ width: "100%" }}>
          <Button
            onClick={onClick}
            sx={{
              fontFamily: "ABCDiaTypeRegular",
              textTransform: "capitalize",
            }}
            startIcon={<Iconify icon={"akar-icons:chevron-left"} />}
          >
            Go Back To Results
          </Button>
        </Box>
      )}
    </Tooltip>
  );
}
